export const Localization = {
  Site: {
    Title: 'Site.Title',
    MainHeader: 'Site.MainHeader',
    Subheader: 'Site.Subheader',
    MainContent1: 'Site.MainContent1',
    MainContent2: 'Site.MainContent2'
  },
  Subscription: {
    Id: 'Subscription.Id',
    NameTitle: 'Subscription.NameTitle',
    StatusTitle: 'Subscription.StatusTitle',
    RequestedByTitle: 'Subscription.RequestedByTitle',
    TenantIdTitle: 'Subscription.TenantIdTitle',
    IsAlreadyActivatedTitle: 'Subscription.IsAlreadyActivatedTitle',
    PlanId: 'Subscription.PlanId'
  }
}